module.exports = __webpack_public_path__ + "static/media/GuruMe_Office_Room6_1.47ef18b7.jpg";